<template>
  <div>
    <vue-spinner v-if="loading.chartsIndex"></vue-spinner>

    <template v-else>

      <template v-if=""></template>

      <div v-if="chartsIndex.length === 0">
        No charts exist. Add a Chart in the <router-link :to="{'name': 'Reports View', 'reportid' : this.reportId, 'hash' : '#summary'}">Summary</router-link> tab.
      </div>

      <div v-for="(chart, idx) in chartsIndex">

        <h4>{{chart.options.title}}</h4>

        <pie-chart
          :id="'chrt'+idx"
          v-if="chart.type === 'pie'"
          :options="chart.options"
          :chartdata="chart.chart_data"
          :show-counters="showCounters"
        />

        <bar-chart
          :id="'chrt'+idx"
          v-if="chart.type === 'bar-vertical'"
          :options="chart.options"
          :chartdata="chart.chart_data"
          :datalabels="showCounters"
        />

        <horizontal-bar-chart
          :id="'chrt'+idx"
          v-if="chart.type === 'bar-horizontal'"
          :options="chart.options"
          :chartdata="chart.chart_data"
          :datalabels="showCounters"
        />

        <line-chart
          :id="'chrt'+idx"
          v-if="chart.type === 'line'"
          :options="chart.options"
          :chartdata="chart.chart_data"
          :datalabels="showCounters"
        />

        <div class="clearfix">&nbsp;</div>

        <a :id="'download-png'+idx" download="chart.png">
          <button class="btn green" @click="downloadPng(idx)">Download PNG</button>
        </a>

        <router-link :to="{name:'Report Summary', params: {reportid: reportId, summaryId: chart.summary_id}, hash: '#chart'}" tag="button" class="btn green pull-right">
          Edit Chart
        </router-link>
        <div class="clearfix"></div>
        <hr v-if="chartsIndex.length > 1">
      </div>

    </template>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner';
  import PieChart from "../../components/charts/PieChart";
  import BarChart from "../../components/charts/BarChart";
  import HorizontalBarChart from "../../components/charts/HorizontalBarChart";
  import LineChart from "../../components/charts/LineChart";
  import {mapGetters, mapActions} from "vuex";

  export default {
    data() {
      return {
        reportId: null,
        showCounters: false,
      }
    },
    components: {
      LineChart,
      HorizontalBarChart,
      BarChart,
      PieChart,
      'breadcrumb-bar': Breadcrumbs,
      'vue-spinner': Spinner
    },
    mounted() {
      if (!this.$route.params.reportid) {
        this.$notify({type: 'error', text: 'Wrong report.'});
        this.$route.push({'name': 'Reports Index'})
      }

      this.reportId = this.$route.params.reportid;
      this.fetchChartsIndex({reportId: this.reportId});
    },
    computed: {
      ...mapGetters({
        'loading': 'getReportsLoading',
        'summaryIndex' : 'getSReportSummaryIndex',
        'chartsIndex' : 'getChartsIndex'
      })
    },
    methods: {
      ...mapActions([
        'fetchChartsIndex'
      ]),
      downloadPng(chartId) {
        // show data labels with counters only when printing chart
        this.showCounters = true;
        this.$nextTick(() => {
          let canvas = document.getElementById('chrt'+chartId).getElementsByTagName('CANVAS')[0];
          let img = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
          let download = document.getElementById('download-png'+chartId);
          download.setAttribute('href', img);
          this.showCounters = false;
        })
      }
    },
  }
</script>





// WEBPACK FOOTER //
// ReportCharts.vue?0ac8b03b